import axios from 'axios'

/**
 * A sessão anda no cookie httpOnly emitido pela API — daí o `withCredentials`. O header `platform`
 * é o que faz o backend ler o cookie do painel de parceiros e não o do app.
 */
export const API_BASE_URL = import.meta.env.VITE_API_URL ?? 'http://localhost:3503'

export const api = axios.create({
  baseURL: API_BASE_URL,
  withCredentials: true,
  headers: {
    platform: 'PARCEIROS',
  },
})
